module.exports = __webpack_public_path__ + "img/table-multi-tool.ace33731.webp";